import { createRouter, createWebHashHistory } from "vue-router"
import AdminView from "../views/admin/AdminView.vue"
import store from "../store/index.js"

const routes = [
    {
        path: `/`,
        name: "HomeView",
        redirect: "/admin/search-all",
        children: [
            {
                path: `/admin`,
                name: "AdminView",
                component: AdminView,
                redirect: "/admin/search-all",
                children: [
                    {
                        path: "/admin/search-all",
                        name: "SuperSearch",
                        component: () => import("../views/admin/search/SuperSearch.vue"),
                    },
                    {
                        path: "/admin/search",
                        name: "SearchView",
                        component: () => import("../views/admin/search/SearchView.vue"),
                    },
                    {
                        path: "/admin/super/static-folder",
                        name: "SuperStaticFolder",
                        component: () => import("../views/admin/super/StaticFolder.vue"),
                    },
                    {
                        path: "/admin/super/static-file",
                        name: "SuperStaticFile",
                        component: () => import("../views/admin/super/StaticFile.vue"),
                    },
                    // app
                    {
                        path: "/admin/app/home-banner",
                        name: "HomeBannerList",
                        component: () => import("../views/admin/app/home-banner/HomeBannerList.vue"),
                    },
                    {
                        path: "/admin/app/home-banner/:id",
                        name: "AddEditHomeBanner",
                        component: () => import("../views/admin/app/home-banner/AddEditHomeBanner.vue"),
                    },
                    {
                        path: "/admin/app/article",
                        name: "AppArticle",
                        component: () => import("../views/admin/app/article/AppArticle.vue"),
                    },

                    {
                        path: "/admin/app/article/:id",
                        name: "AddEditAppArticle",
                        component: () => import("../views/admin/app/article/AddEditAppArticle.vue"),
                    },
                    {
                        path: "/admin/app/order-status",
                        name: "AppOrderStatus",
                        component: () => import("../views/admin/app/order-status/AppOrderStatus.vue"),
                    },
                    {
                        path: "/admin/app/order-status/:id",
                        name: "EditAppOrderStatus",
                        component: () => import("../views/admin/app/order-status/EditAppOrderStatus.vue"),
                    },
                    {
                        path: "/admin/app/order-status-send",
                        name: "AppSendOrderStatus",
                        component: () => import("../views/admin/app/order-status-send/AppSendOrderStatus.vue"),
                    },
                    {
                        path: "/admin/app/order-status-send/:id",
                        name: "EditSendAppOrderStatus",
                        component: () => import("../views/admin/app/order-status-send/EditSendAppOrderStatus.vue"),
                    },
                    {
                        path: "/admin/app/custom-info",
                        name: "AppCustomInfo",
                        component: () => import("../views/admin/app/custom-info/CustomInfo.vue"),
                    },
                    {
                        path: "/admin/app/version",
                        name: "AppVersion",
                        component: () => import("../views/admin/app/version/AppVersion.vue"),
                    },
                    {
                        path: "/admin/app/version/:id",
                        name: "EditAppVersion",
                        component: () => import("../views/admin/app/version/EditAppVersion.vue"),
                    },
                    {
                        path: "/admin/app/invite",
                        name: "AppInviteList",
                        component: () => import("../views/admin/app/invite/InviteList.vue"),
                    },
                    {
                        path: "/admin/app/video-guide",
                        name: "VideoGuideList",
                        component: () => import("../views/admin/app/video-guide/VideoGuideList.vue"),
                    },
                    {
                        path: "/admin/app/video-guide/:id",
                        name: "AddEditVideoGuide",
                        component: () => import("../views/admin/app/video-guide/AddEditVideoGuide.vue"),
                    },
                    {
                        path: "/admin/app/stories-group",
                        name: "StoriesGroup",
                        component: () => import("../views/admin/app/stories-group/StoriesGroup.vue"),
                    },
                    {
                        path: "/admin/app/stories-group/:id",
                        name: "AddEditStoriesGroup",
                        component: () => import("../views/admin/app/stories-group/AddEditStoriesGroup.vue"),
                    },
                    {
                        path: "/admin/app/stories-group/story/:id",
                        name: "AddEditAppStory",
                        component: () => import("../views/admin/app/stories-group/story/AddEditAppStory.vue"),
                    },
                    {
                        path: "/admin/app/push-category",
                        name: "PushCategory",
                        component: () => import("../views/admin/app/push-category/PushCategory.vue"),
                    },
                    {
                        path: "/admin/app/push-category/:id",
                        name: "AddEditPushCategory",
                        component: () => import("../views/admin/app/push-category/AddEditPushCategory.vue"),
                    },
                    {
                        path: "/admin/app/back-to-school",
                        name: "BackToSchool",
                        component: () => import("../views/admin/app/back-to-school/BackToSchool.vue"),
                    },
                    {
                        path: "/admin/app/service",
                        name: "AppService",
                        component: () => import("../views/admin/app/service/AppService.vue"),
                    },
                    {
                        path: "/admin/app/service/:id",
                        name: "AddEditAppService",
                        component: () => import("../views/admin/app/service/AddEditAppService.vue"),
                    },
                    {
                        path: "/admin/app/deep-link",
                        name: "DeepLinkList",
                        component: () => import("../views/admin/app/deep-link/DeepLinkList.vue"),
                    },
                    // statistics
                    {
                        path: "/admin/statistics/mastercard",
                        name: "MastercardView",
                        component: () => import("../views/admin/statistics/mastercard/MastercardView.vue"),
                    },
                    {
                        path: "/admin/statistics/stories-banner",
                        name: "StoriesBannerStatisticsView",
                        component: () => import("../views/admin/statistics/stories-banner/StoriesBannerStatisticsView.vue"),
                    },
                    {
                        path: "/admin/deleted-accounts",
                        name: "DeleteAccountStatistics",
                        component: () => import("../views/admin/statistics/delete-account/DeleteAccountStatistics.vue"),
                    },
                    {
                        path: "/admin/deleted-accounts/:id",
                        name: "EditDeleteAccount",
                        component: () => import("../views/admin/statistics/delete-account/EditDeleteAccount.vue"),
                    },
                    {
                        path: "/admin/app/china-warehouse-address",
                        name: "ChinaWarehouseAddress",
                        component: () => import("../views/admin/app/china-warehouse-address/ChinaWarehouseAddress.vue"),
                    },
                    {
                        path: "/admin/app/china-warehouse-address/:id",
                        name: "AddEditChinaWarehouseAddress",
                        component: () => import("../views/admin/app/china-warehouse-address/AddEditChinaWarehouseAddress.vue"),
                    },

                    {
                        path: "/admin/app/marketplace",
                        name: "AppMarketplace",
                        component: () => import("../views/admin/app/marketplace/AppMarketplace.vue"),
                    },
                    {
                        path: "/admin/app/marketplace/:id",
                        name: "AddEditMarketplace",
                        component: () => import("../views/admin/app/marketplace/AddEditMarketplace.vue"),
                    },
                    {
                        path: "/admin/app/remote-config/info",
                        name: "RemoteConfigInfo",
                        component: () => import("../views/admin/app/remote-config/RemoteConfigInfo.vue"),
                    },
                    {
                        path: "/admin/app/remote-config/social",
                        name: "RemoteConfigSocial",
                        component: () => import("../views/admin/app/remote-config/RemoteConfigSocial.vue"),
                    },
                    {
                        path: "/admin/app/remote-config/legal",
                        name: "RemoteConfigLegal",
                        component: () => import("../views/admin/app/remote-config/RemoteConfigLegal.vue"),
                    },
                    {
                        path: "/admin/app/remote-config/features",
                        name: "RemoteConfigFeatures",
                        component: () => import("../views/admin/app/remote-config/RemoteConfigFeatures.vue"),
                    },
                    {
                        path: "/admin/app/remote-config/devmode",
                        name: "RemoteConfigDevmode",
                        component: () => import("../views/admin/app/remote-config/RemoteConfigDevmode.vue"),
                    },
                    {
                        path: "/admin/app/remote-config/home-page-promo-icon",
                        name: "RemoteConfigHomePagePromoIcon",
                        component: () => import("../views/admin/app/remote-config/RemoteConfigHomePagePromoIcon.vue"),
                    },
                    {
                        path: "/admin/app/remote-config/custom-order",
                        name: "RemoteConfigCustomOrder",
                        component: () => import("../views/admin/app/remote-config/RemoteConfigCustomOrder.vue"),
                    },
                    {
                        path: "/admin/app/remote-config/feature-flags",
                        name: "FeatureFlagsList",
                        component: () => import("../views/admin/app/remote-config/feature-flags/FeatureFlagsList.vue"),
                    },
                    {
                        path: "/admin/app/remote-config/feature-flags/:id",
                        name: "AddEditFeatureFlag",
                        component: () => import("../views/admin/app/remote-config/feature-flags/AddEditFeatureFlag.vue"),
                    },
                    {
                        path: "/admin/app/remote-config/control-groups",
                        name: "ControlGroupsList",
                        component: () => import("../views/admin/app/remote-config/control-groups/ControlGroupsList.vue"),
                    },
                    {
                        path: "/admin/app/remote-config/control-groups/:id",
                        name: "AddEditControlGroup",
                        component: () => import("../views/admin/app/remote-config/control-groups/AddEditControlGroup.vue"),
                    },

                    // faq
                    {
                        path: "/admin/faq/article",
                        name: "FaqArticleList",
                        component: () => import("../views/admin/faq/article/FaqArticleList.vue"),
                    },
                    {
                        path: "/admin/faq/article/:id",
                        name: "AddEditFaqArticle",
                        component: () => import("../views/admin/faq/article/AddEditFaqArticle.vue"),
                    },
                    {
                        path: "/admin/faq/category",
                        name: "FaqCategoryList",
                        component: () => import("../views/admin/faq/category/FaqCategoryList.vue"),
                    },
                    {
                        path: "/admin/faq/category/:id",
                        name: "AddEditFaqCategory",
                        component: () => import("../views/admin/faq/category/AddEditFaqCategory.vue"),
                    },
                    {
                        path: "/admin/faq/response",
                        name: "FaqResponse",
                        component: () => import("../views/admin/faq/FaqResponse.vue"),
                    },
                    // user
                    {
                        path: "/admin/user",
                        name: "UserView",
                        component: () => import("../views/admin/user/UserView.vue"),
                    },
                    {
                        path: "/admin/user/:id",
                        name: "EditUser",
                        component: () => import("../views/admin/user/EditUser.vue"),
                    },
                    // ship
                    {
                        path: "/admin/ship",
                        name: "ShipView",
                        component: () => import("../views/admin/ship/ShipView.vue"),
                    },
                    {
                        path: "/admin/ship/:id",
                        name: "EditShip",
                        component: () => import("../views/admin/ship/EditShip.vue"),
                    },

                    // settings
                    {
                        path: "/admin/settings/sub-order-status",
                        name: "SubOrderStatus",
                        component: () => import("../views/admin/settings/sub-order-status/SubOrderStatus.vue"),
                    },
                    {
                        path: "/admin/settings/sub-order-status/:id",
                        name: "EditSubOrderStatus",
                        component: () => import("../views/admin/settings/sub-order-status/EditSubOrderStatus.vue"),
                    },
                    {
                        path: "/admin/settings/public-document",
                        name: "PublicDocument",
                        component: () => import("../views/admin/settings/public-document/PublicDocument.vue"),
                    },
                    {
                        path: "/admin/settings/public-document/:id",
                        name: "EditPublicDocument",
                        component: () => import("../views/admin/settings/public-document/EditPublicDocument.vue"),
                    },
                    //translate / category
                    {
                        path: "/admin/settings/translate/category",
                        name: "TranslateCategory",
                        component: () => import("../views/admin/settings/translate/category/TranslateCategory.vue"),
                    },
                    {
                        path: "/admin/settings/translate/category/:id",
                        name: "EditTranslateCategory",
                        component: () => import("../views/admin/settings/translate/category/EditTranslateCategory.vue"),
                    },
                    //translate / category
                    {
                        path: "/admin/settings/translate",
                        name: "TranslateView",
                        component: () => import("../views/admin/settings/translate/TranslateView.vue"),
                    },
                    {
                        path: "/admin/settings/translate/:id",
                        name: "EditTranslate",
                        component: () => import("../views/admin/settings/translate/EditTranslate.vue"),
                    },
                    // question-rate
                    {
                        path: "/admin/question-rate",
                        name: "QuestionRate",
                        component: () => import("../views/admin/question-rate/QuestionRate.vue"),
                    },
                    {
                        path: "/admin/question-rate/:id",
                        name: "EditQuestionRate",
                        component: () => import("../views/admin/question-rate/EditQuestionRate.vue"),
                    },
                    {
                        path: "/admin/rate/list",
                        name: "RatingList",
                        component: () => import("../views/admin/question-rate/RatingList.vue"),
                    },
                    // template
                    {
                        path: "/admin/temp",
                        name: "TempList",
                        component: () => import("../views/admin/temp/TempList.vue"),
                    },
                    {
                        path: "/admin/temp/:id",
                        name: "EditTemp",
                        component: () => import("../views/admin/temp/EditTemp.vue"),
                    },

                    // feedback
                    {
                        path: "/admin/feedback",
                        name: "FeedbackView",
                        component: () => import("../views/admin/feedback/FeedbackView.vue"),
                    },
                    {
                        path: "/admin/feedback/:id",
                        name: "EditFeedback",
                        component: () => import("../views/admin/feedback/EditFeedback.vue"),
                    },
                    {
                        path: "/admin/feedback/reason-status/list",
                        name: "FeedbackReasonStatusList",
                        component: () => import("@/views/admin/feedback/reason-status/FeedbackReasonStatusList.vue"),
                    },
                    {
                        path: "/admin/feedback/reason-status/:id",
                        name: "EditFeedbackReasonStatus",
                        component: () => import("@/views/admin/feedback/reason-status/EditFeedbackReasonStatus.vue"),
                    },
                    {
                        path: "/admin/feedback/result-status/list",
                        name: "FeedbackResultStatusList",
                        component: () => import("../views/admin/feedback/result-status/FeedbackResultStatusList.vue"),
                    },
                    {
                        path: "/admin/feedback/result-status/:id",
                        name: "EditFeedbackResultStatus",
                        component: () => import("../views/admin/feedback/result-status/EditFeedbackResultStatus.vue"),
                    },
                    {
                        path: "/admin/feedback/refound-account/list",
                        name: "FeedbackRefundAccountList",
                        component: () => import("../views/admin/feedback/refund-account/FeedbackRefundAccountList.vue"),
                    },
                    {
                        path: "/admin/feedback/refound-account/:id",
                        name: "EditFeedbackRefundAccount",
                        component: () => import("../views/admin/feedback/refund-account/EditFeedbackRefundAccount.vue"),
                    },
                    // staff-discount
                    {
                        path: "/admin/staff-discount/list",
                        name: "StaffDiscountList",
                        component: () => import("../views/admin/staff-discount/StaffDiscountList.vue"),
                    },
                    {
                        path: "admin/staff-discount/add",
                        name: "AddStaffDiscount",
                        component: () => import("@/views/admin/staff-discount/AddStaffDiscount.vue"),
                    },
                    // push
                    {
                        path: "/admin/push/new-branch",
                        name: "PushByNewBranch",
                        component: () => import("../views/admin/push/PushByNewBranch.vue"),
                    },
                    {
                        path: "/admin/push/file",
                        name: "PushByFile",
                        component: () => import("../views/admin/push/PushByFile.vue"),
                    },
                    {
                        path: "/admin/push/filter",
                        name: "PushByFilter",
                        component: () => import("../views/admin/push/PushByFilter.vue"),
                    },
                    {
                        path: "/admin/push/category",
                        name: "PushByCategory",
                        component: () => import("../views/admin/push/PushByCategory.vue"),
                    },
                    // account
                    {
                        path: "/admin/account",
                        name: "AccountView",
                        component: () => import("../views/admin/account/AccountView.vue"),
                    },
                    {
                        path: "/admin/account/:id",
                        name: "EditAccount",
                        component: () => import("../views/admin/account/EditAccount.vue"),
                    },
                    // temp
                    {
                        path: "/admin/temp",
                        name: "TempList",
                        component: () => import("../views/admin/temp/TempList.vue"),
                    },
                    {
                        path: "/admin/console/update-password",
                        name: "UpdatePassword",
                        component: () => import("../views/admin/console/UpdatePassword.vue"),
                    },
                    {
                        path: "/admin/supervision/china-address-copy",
                        name: "ChinaAddressCopy",
                        component: () => import("../views/admin/supervision/ChinaAddressCopy.vue"),
                    },
                    {
                        path: "/admin/vip",
                        name: "VIPClient",
                        component: () => import("../views/admin/vip/VIPClient.vue"),
                    },
                    // Promo Code
                    {
                        path: "/admin/referral-promo/promo-code",
                        name: "PromoCodeList",
                        component: () => import("../views/admin/referral-promo/promo-code/PromoCodeList.vue"),
                    },
                    {
                        path: "/admin/referral-promo/system",
                        name: "SystemPromoCode",
                        component: () => import("../views/admin/referral-promo/system/SystemPromoCode.vue"),
                    },
                    {
                        path: "/admin/referral-promo/system/add",
                        name: "AddSystemSend",
                        component: () => import("../views/admin/referral-promo/system/AddSystemPromoCode.vue"),
                    },
                    {
                        path: "/admin/promotion",
                        name: "PromocodeActionsList",
                        component: () => import("../views/admin/promotion/PromotionList.vue"),
                    },
                    {
                        path: "/admin/promotion/add",
                        name: "AddPromotion",
                        component: () => import("../views/admin/promotion/AddPromotion.vue"),
                    },
                    {
                        path: "/admin/promotion/:id",
                        name: "PromotionStatisticView",
                        component: () => import("../views/admin/promotion/PromotionStatisticView.vue"),
                    },
                ],
            },
        ],
    },
    {
        path: "/login",
        name: "LoginView",
        component: () => import("../views/LoginView.vue"),
    },
    {
        path: "/404",
        name: "NotFound",
        component: () => import("../views/NotFound.vue"),
    },
    {
        path: "/test",
        name: "TestView",
        component: () => import("../views/TestView.vue"),
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    // base: '/'+locale
})

router.beforeEach((to, from, next) => {
    if (store.getters.hasLogin === true) {
        if (to.matched.length === 0) {
            from.path
                ? next({
                      name: from.name,
                  })
                : next("/404")
        } else {
            next()
        }
        return
    } else if (to.path.indexOf("/login") == -1) {
        store.commit("signOut")
        return
    } else {
        next()
        return
    }
})

export default router
